import React, { forwardRef } from 'react';
import PropTypes from 'prop-types';
import { has, isUndefined } from 'lodash';

const TableItemCellRenderer = forwardRef(
  ({ className, value, colDef }, ref) => {
    const { cellRendererParams } = colDef;
    const { fmt, customisation } = cellRendererParams || {};

    const processedValue =
      !isUndefined(value) && fmt ? fmt(value, customisation) : value;

    // It is possible that the path exists, but the value of the path is undefined.
    // This is why we use 'has' instead of 'get'
    const display = has(value, 'display')
      ? processedValue.display
      : processedValue;

    const processedDisplay = isUndefined(display) ? '' : display;

    return <span ref={ref} className={className}>{`${processedDisplay}`}</span>;
  }
);

TableItemCellRenderer.propTypes = {
  className: PropTypes.string,
  value: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
    PropTypes.shape({
      display: PropTypes.string,
    }),
  ]),
  colDef: PropTypes.shape({
    cellRenderParams: PropTypes.object,
  }).isRequired,
};

TableItemCellRenderer.defaults = {
  className: '',
};

export default TableItemCellRenderer;
export { TableItemCellRenderer };
